import type { User } from "@/types/api/person"

export function getFullName (user: User, localize: Function): string {
  const names = [
    user.lastName,
    user.firstName,
    user.patronymic,
  ]
    .map(n => localize(n))
    .filter(Boolean)

  if (!names.length) return ""

  const head = names.shift()
  const tail = names.map(n => `${n[0]}.`).join(" ")

  return `${head} ${tail}`
}
